module.exports = __webpack_public_path__ + "static/media/Extreme.fa4dea24.svg";